import styled from 'styled-components';

import { colors } from '../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  position: absolute;
  min-width: 240px;
  top: 30px;
  right: 0;

  background: ${colors('white.base')};
  border: 1px solid ${colors('black.08')};
  box-shadow: 0px 4px 16px ${colors('black.15')};
  border-radius: 8px;
`;
